<template>
  <base-section
    id="keep-in-touch2"
    space="56"
  >
    <v-container>
      <v-row justify="space-between">
        <v-col
          cols="12"
          md="6"
        >
          <base-info-card
            :title="$t('contact.title2')"
            size="text-h5"
            mobile-size="text-h5"
            space="6"
          >
            {{ $t('contact.content1') }}
          </base-info-card>
        </v-col>

        <v-col
          cols="12"
          md="6"
        >
          <base-section-heading
            :title="$t('contact.title')"
            size="text-h5"
            mobile-size="text-h5"
            space="4"
            color="#142d7a"
          />

          <v-row>
            <v-col
              cols="6"
              class="text-center"
            >
              <div class="qr-container">
                <v-img
                  :src="qr1"
                  max-width="200"
                  class="mx-auto mb-2"
                />
                <div class="qr-label">
                  WhatsApp
                </div>
              </div>
            </v-col>

            <v-col
              cols="6"
              class="text-center"
            >
              <div class="qr-container">
                <v-img
                  :src="qr2"
                  max-width="200"
                  class="mx-auto mb-2"
                />
                <div class="qr-label">
                  Telegram
                </div>
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'KeepInTouch2',
    data() {
      return {
        qr1: require('@/assets/qr/qr1.png'),
        qr2: require('@/assets/qr/qr2.jpg'),
      }
    },
  }
</script>

<style lang="sass" scoped>
.qr-container
  padding: 16px

.qr-label
  font-size: 18px
  font-weight: 500
  color: #142d7a
  margin-top: 8px
</style>
